import wall_brick_veneer from './HomeRoll_Walls_BrkVeneerWall.jpg';
import wall_tin from './tin-wall-material-home-ll.png';
import wall_aluminium_clad from './HomeRoll_Walls_AluCladdWall.jpg';
import wall_colourbond_steel from './HomeRoll_Walls_ColorBSteelWall.jpg';
import wall_concrete_brick from './HomeRoll_Walls_ConcreteBWall.jpg';
import wall_corrigated_iron from './HomeRoll_Walls_CorrIronWall.jpg';
import wall_double_brick from './HomeRoll_Walls_DoubleBrkWalll.jpg';
import wall_cement_fibre from './HomeRoll_Walls_FibCFibWall.jpg';
import wall_mud_brick from './HomeRoll_Walls_MudBrkWall.jpg';
import wall_stone from './HomeRoll_Walls_StoneWall.jpg';
import wall_timber from './HomeRoll_Walls_WbOtherTimberWall.jpg';

import Roof_AluCladRoof from './HomeRoll_Roof_AluCladRoof.jpg';
import Roof_CementRoof from './HomeRoll_Roof_CementRoof.jpg';
import Roof_ClayTerrRoof from './HomeRoll_Roof_ClayTerrRoof.jpg';
import Roof_ColorBondRoof from './HomeRoll_Roof_ColorBondRoof.jpg';
import Roof_ConcreteRoof from './HomeRoll_Roof_ConcreteRoof.jpg';
import Roof_CorrIronRoof from './HomeRoll_Roof_CorrIronRoof.jpg';
import Roof_FibreCemRoof from './HomeRoll_Roof_FibreCemRoof.jpg';
import Roof_SlateRoof from './HomeRoll_Roof_SlateRoof.jpg';
import Roof_Tin from './HomeRoll_Roof_TinRoof.jpg';

export const IMAGES = {
  WALL_MATERIALS: {
    BRICK_VENEER: wall_brick_veneer,
    TIN: wall_tin,
    ALUMINIUM_CLAD: wall_aluminium_clad,
    COLORBOND_STEEL: wall_colourbond_steel,
    CONCRETE_BRICK: wall_concrete_brick,
    CORRIGATED_IRON: wall_corrigated_iron,
    DOUBLE_BRICK: wall_double_brick,
    CEMENT_FIBRE: wall_cement_fibre,
    MUD_BRICK: wall_mud_brick,
    STONE: wall_stone,
    TIMBER: wall_timber,
  },
  ROOF_MATERIALS: {
    AlmCld: Roof_AluCladRoof,
    Cement: Roof_CementRoof,
    TiledRoof: Roof_ClayTerrRoof,
    Colorbond: Roof_ColorBondRoof,
    Concrete: Roof_ConcreteRoof,
    CorrIron: Roof_CorrIronRoof,
    Fibro: Roof_FibreCemRoof,
    Slate: Roof_SlateRoof,
    Tin: Roof_Tin,
  },
};

export default IMAGES;
